import { IssueTicketForm } from 'src/components/issue/tickets/form';
import { IssueTicket } from '../../config';
import { IssueTicketsDocument } from 'src/graphql/generated/graphql';
import { AssignModal } from './assign-modal';
import { ChangeStatusModal } from './change-status-modal';

export enum IssueTicketAction {
  Edit = 'edit',
  Assign = 'assign',
  Status = 'status',
}

const refetchQueries = [IssueTicketsDocument];

type ActionModalsProps = {
  issueTicket: IssueTicket;
  action: IssueTicketAction;
  onClose: () => void;
};

export const ActionModals = ({
  issueTicket,
  action,
  onClose,
}: ActionModalsProps) => {
  return (
    <>
      {action === IssueTicketAction.Edit && (
        <IssueTicketForm
          issueTicket={issueTicket}
          refetchQueries={refetchQueries}
          onSave={onClose}
          onCancel={onClose}
        />
      )}
      {action === IssueTicketAction.Assign && (
        <AssignModal
          issueTicket={issueTicket}
          refetchQueries={refetchQueries}
          onClose={onClose}
        />
      )}
      {action === IssueTicketAction.Status && (
        <ChangeStatusModal
          issueTicket={issueTicket}
          refetchQueries={refetchQueries}
          onClose={onClose}
        />
      )}
    </>
  );
};
